import { connect } from 'react-redux';
import GoogleAnalyticsActivationView from './GoogleAnalyticsActivationView.jsx';
import { activateAccount } from 'src/legacy/redux/actions/integrations/googleAnalytics.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';

const mapStateToProps = (state, ownProps) => {
  return {
    activating: state.legacyRootReducer.settings.integrations.googleAnalytics.activation.activating,
    error: state.legacyRootReducer.settings.integrations.googleAnalytics.activation.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration) => {
        return dispatch(activateAccount(configuration))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName))
    }
  }
}

const GoogleAnalyticsActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(GoogleAnalyticsActivationView);

export default GoogleAnalyticsActivationPage;
